export default __webpack_public_path__ + "static/media/09.15eb1112.jpg";